export function createModelFilterFormData (namespaced) {
  return {
    modelFilterFormData: {
      get () {
        return this.$store.getters[`${namespaced}/getFilterFormData`]
      },
      set (data) {
        this.$store.commit(`${namespaced}/SET_FILTER_FORM_DATA`, data)
      }
    }
  }
}
